import { useState, useEffect } from 'react';
import { throttle } from 'underscore';

function getDimensions (current, useBoundingClientRect) {
  if (useBoundingClientRect) {
    return current.getBoundingClientRect();
  }

  const { offsetWidth: width, offsetHeight: height } = current;
  return { width, height };
}

export default function useDimensions (ref, { useBoundingClientRect = false } = {}) {
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });

  function handleResize () {
    setDimensions(getDimensions(ref.current, useBoundingClientRect));
  }

  const throttledHandleResize = throttle(handleResize, 100);

  useEffect(() => {
    if (ref.current) handleResize();

    window.addEventListener('resize', throttledHandleResize);
    return () => window.removeEventListener('resize', throttledHandleResize);
  }, [ref]);

  return dimensions;
}
